import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/Home';

import './styles/site.scss';

interface AppProps {};

export const App: React.FC<AppProps> = (props: React.PropsWithChildren<AppProps>) => {
    return (
        <Layout>
            <Routes>
                <Route path="/:config?" index element={<Home />} />
            </Routes>
        </Layout>
    );
};